import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=26d5a9a7&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=26d5a9a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d5a9a7",
  null
  
)

export default component.exports